import { Bounds, Vector } from '@ardoq/graph';
import { rectCenter } from 'tabview/visualizations/misc/geometry';
import { AqBlocks } from '../types';
import { RenderParameters } from '../visual/types';
import { DragHandler } from './types';

export class PanDragHandler implements DragHandler {
  public get cursor(): string {
    return 'grabbing';
  }

  public constructor(component: AqBlocks) {
    this.component = component;
    this.window = component.projection.window;
    this.center = rectCenter(component.projection.window);
    this.pointerDown = component.pointerDown;
  }

  private readonly pointerDown: Vector;

  public drag() {
    this.component.panTo(this.pointerDown, this.component.pointerViewport);
  }

  public render(_params: RenderParameters) {}

  public done() {}

  public cancel() {
    this.component.adjustToRect(this.window);
  }

  private readonly component: AqBlocks;
  private readonly window: Bounds;
  private readonly center: Vector;
}
